"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubContact = void 0;
/**
 * This entity represents a sub-contact. It is serialized in JSON and saved in the underlying icure-contact CouchDB database.
 */
class SubContact {
    constructor(json) {
        Object.assign(this, json);
    }
}
exports.SubContact = SubContact;
//# sourceMappingURL=SubContact.js.map